import moment from "moment"
import "moment/locale/cs"
import { generateEmailHeading2, generateEmailParagraph, spaceDivider } from "../generateEmailParagraph"
import { thankYou } from "./subDefinitions/emailComponents"

moment.locale("cs")

export const emailDefinitionContactForm = (
  email: string,
  message: string,
  contactFormName: string,
  contactFormUrl: string,
  courseListOffer: string
): string => `
  ${generateEmailParagraph(
    `Zpráva z <a href="${contactFormUrl}?utm_source=contact_form&utm_medium=email" title="Otevřít stránku ${contactFormName}" target="_blank">kontaktního formuláře - ${contactFormName}</a>,`
  )}
  
  ${generateEmailParagraph(`od <strong>"${email}"</strong> Vám posílá:`)}

  ${generateEmailParagraph(message)}
  
  ${spaceDivider}
  
  ${
    courseListOffer?.length > 0
      ? `
      ${generateEmailHeading2("Aktuálně naše otevřené kurzy", "https://vzdelanibudoucnosti.cz/pocitacove-krouzky-pro-deti", "margin-bottom: -15px;")}
      ${courseListOffer}
      `
      : ""
  }
  
  ${thankYou}
`
